import { render } from "./StoreRegister.vue?vue&type=template&id=93b3b0be&scoped=true"
import script from "./StoreRegister.vue?vue&type=script&lang=js"
export * from "./StoreRegister.vue?vue&type=script&lang=js"

import "./StoreRegister.vue?vue&type=style&index=0&id=93b3b0be&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b3b0be"]])

export default __exports__